import { createSelector } from '@reduxjs/toolkit';

import {
  selectCalculatorVersion,
  selectCostMultiplier,
  selectDataSetVersion,
  selectEffectiveYear,
} from '../orderSelectors.ts';

export const selectCostProps = createSelector(
  [selectDataSetVersion, selectCalculatorVersion, selectCostMultiplier, selectEffectiveYear],
  (datasetVersion, calculatorVersion, costMultiplier, effectiveYear) => {
    return {
      datasetVersion,
      calculatorVersion,
      costMultiplier,
      effectiveYear,
    };
  },
);
